import Navbar from "./components/Navbar";
import CompanySection from "./components/CompanySection";
import ProductsSection from "./components/ProductsSection";
import FeaturesSection from "./components/FeaturesSection";
import SecuritySection from "./components/SecuritySection";
import ContactSection from "./components/ContactSection";

export default function Home() {
  return (
    <main className="min-h-screen" style={{ fontFamily: "'Inter', sans-serif" }}>
      <Navbar />
      <CompanySection />
      <ProductsSection />
      <FeaturesSection />
      <SecuritySection />
      <ContactSection />
    </main>
  );
}
